<template>
    <div class="row bs-wizard">
      <!-- <template v-for=" step in steps ">
        <div class="col-md-2" :class="{ active: (step.step == activeStep) ? true : false }">
          <span class="step">{{ step.step }}</span>
          <span class="stepName">{{ step.name }}</span>
        </div>
      </template>
 -->     
      <template v-for=" step in steps ">
        <div :class="'col-xs-4 bs-wizard-step '+ ( (step.step < getPasoCompra) ? 'complete' : ( (step.step == getPasoCompra) ? 'active' : 'disabled') )">
          <div class="text-center bs-wizard-stepnum">{{ step.step }}</div>
          <div class="progress"><div class="progress-bar"></div></div>
          <template v-if="step.link">
            <router-link 
              :to="{ name: step.link, params: { language: getLocale } }"
              class="bs-wizard-dot"></router-link>
          </template>
          <a v-else href="#" class="bs-wizard-dot" v-on:click.prevent></a>
          <div class="bs-wizard-info text-center">{{ step.name }}</div>
        </div>
      </template>
      
       <!--  
       + ( (step.step < activeStep) ? 'complete' : ( (step.step == activeStep) ? 'active' : 'disabled') ) 

       <div class="col-xs-3 bs-wizard-step complete">
          <div class="text-center bs-wizard-stepnum">Step 2</div>
          <div class="progress"><div class="progress-bar"></div></div>
          <a href="#" class="bs-wizard-dot"></a>
          <div class="bs-wizard-info text-center"></div>
        </div>
        
        <div class="col-xs-3 bs-wizard-step active">
          <div class="text-center bs-wizard-stepnum">Step 3</div>
          <div class="progress"><div class="progress-bar"></div></div>
          <a href="#" class="bs-wizard-dot"></a>
          <div class="bs-wizard-info text-center"></div>
        </div>
        
        <div class="col-xs-3 bs-wizard-step disabled">
          <div class="text-center bs-wizard-stepnum">Step 4</div>
          <div class="progress"><div class="progress-bar"></div></div>
          <a href="#" class="bs-wizard-dot"></a>
          <div class="bs-wizard-info text-center"></div>
        </div> -->

    </div>
</template>

<i18n>
{
  "es": {
    "Seleccionar": "Seleccionar",
    "Comprar": "Comprar",
    "Confirmar y enviar pedido": "Confirmar y enviar pedido",
    "Enviar pedido": "Enviar pedido",
    "Guardar pedido": "Guardar pedido",
    "Finalizar": "Finalizar"
  },
  "en": {
  },
  "ca": {
    "Seleccionar": "Seleccionar",
    "Comprar": "Comprar",
    "Confirmar y enviar pedido": "Confirmar i enviar comanda",
    "Enviar pedido": "Enviar comanda",
    "Guardar pedido": "Desar comanda",
    "Finalizar": "Finalitzar"
  }
}
</i18n>

<script>
  import { mapGetters } from 'vuex';

	export default {
    //props: ['activeStep'],
    data: () => {
      return {
        steps: []
      }
    },
    mounted(){
      //this.activeStep = this.getPasoPedido;
      /*this.steps = [
        {
          step: 1,
          name: this.$t('Seleccionar'),
          link: 'seleccion' // ROUTE NAME
        },
        {
          step: 2,
          name: this.$t('Confirmar y enviar pedido'),
          link: false
        },
        {
          step: 3,
          name: this.$t('Guardar pedido'),
          link: false
        }
      ]*/
      this.loadData();
    },
    computed:{
      ...mapGetters(['getLocale', 'getPasoCompra']),
    },
    methods:{
      loadData(){
        this.steps = [
          {
            step: 1,
            name: this.$t('Seleccionar'),
            link: 'seleccion' // ROUTE NAME
          },
          {
            step: 2,
            name: this.$t('Confirmar y enviar pedido'),
            link: false
          },
          {
            step: 3,
            name: this.$t('Guardar pedido'),
            link: false
          }
        ]
      }
    },
    watch:{
      $route: function(){
        this.loadData();
      }
    } 
  }
</script>
